import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"

export const DetailItem = ({ label, children }: { label: string; children: ReactNode }) => {
  const isComponent = typeof children !== "string" && typeof children !== "number"
  return (
    <div className="block-one-card_info-item text-sm text-black">
      <div className="block-one-card_info-label text-sm">
        <FormattedMessage id={label} />
      </div>
      {isComponent ? <div className="block-one-card_info-value text-sm">{children}</div> : children}
    </div>
  )
}
